import React, { useEffect, useState } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import logo from '../../assets/images/logo.png';
import { PatientAgreement, Agree, Success, OwnerAgreement } from './components';
import {
  Grid,
  Box,
  withStyles,
  AppBar,
  Toolbar,
  Fab,
  CircularProgress
} from '@material-ui/core';
import styles from './termsStyle';
import { connect } from 'react-redux';
import { activateAccount, getuserbytoken } from 'services/user/action';
import { Roles } from 'util/enum';

const Terms = props => {
  const { classes, getuserbytoken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showterms, setShowTerms] = useState({
    terms: true,
    success: false,
    isProvider: false,
    isPatient: false,
    isOwner: false,
    isStaff: false
  });
  const [data, setData] = useState();

  useEffect(() => {
    if (props.location && props.location.state && props.location.state.data) {
      fetchData(props.location.state.data.token);
      setData(props.location.state.data);
    } else {
      setShowTerms(prev => ({ ...prev, isOwner: true }));
    }

    async function fetchData(token) {
      const res = await getuserbytoken(token);
      if (res.data.role === Roles.provider) {
        setShowTerms(prev => ({ ...prev, isProvider: true }));
      }
      if (res.data.role === Roles.staff) {
        setShowTerms(prev => ({ ...prev, isStaff: true }));
      }
      if (res.data.role === Roles.patient) {
        setShowTerms(prev => ({ ...prev, isPatient: true }));
      }
    }
  }, [props.location && props.location.state, getuserbytoken]);

  const [values, setValues] = useState({
    name: '',
    organizationname: ''
  });

  const showSuccess = () => {
    setShowTerms(prev => ({
      ...prev,
      terms: false,
      success: true
    }));
  };

  useEffect(() => {
    if (props.location && props.location.state) {
      setValues({
        name: props.location.state.name,
        organizationname: props.location.state.organizationname
      });
    }
  }, [props.location]);

  const handleActivateAccount = async () => {
    setIsLoading(true);
    const res = await props.activateAccount(data.ehrid, data.token, data);

    if (res && (res.data.role === 'ROLE_PROVIDER' || res.data.role === 'ROLE_STAFF')) {
      props.history.push('/sign-in');
      setIsLoading(false);
    } else if (res && res.data.role === 'ROLE_PATIENT') {
      props.history.push('/pt-login');
      setIsLoading(false);
    } else {
      setValues(prev => ({ ...prev, isLoading: false, succMsg: false }));
      setIsLoading(false);
    }
  };

  const showProviderOrStaff = showterms.terms && (showterms.isProvider || showterms.isStaff);
  const showPatient = showterms.terms && showterms.isPatient;
  const showOwner = showterms.terms && showterms.isOwner;

  return (
    <div className={classes.root}>
      <AppBar className={classes.headerWrap} position="relative">
        <Toolbar className={classes.toolbar}>
          <Box className={classes.naviWrap}>
            <RouterLink to="/">
              <img alt="Logo" className={classes.logoImg} src={logo} />
            </RouterLink>
          </Box>
        </Toolbar>
      </AppBar>

      <Grid container className={classes.mainGrid}>
        <Grid item xs={12}>
          <Box className={classes.contentContainer}>
            {showProviderOrStaff && (
              <>
                <Agree />
                <div className={classes.buttonWrap}>
                  <Fab
                    aria-label="accept"
                    className={classes.roundButton}
                    color="primary"
                    onClick={handleActivateAccount}
                    size="medium"
                    variant="extended"
                  >
                    {isLoading && (
                      <CircularProgress
                        size={20}
                        style={{ marginRight: 5 }}
                        color="inherit"
                      />
                    )}
                    I have read and accept the terms of service
                  </Fab>
                  <Fab
                    aria-label="cancel"
                    className={classes.roundButton}
                    color="default"
                    component={RouterLink}
                    size="medium"
                    to="/sign-up"
                    variant="extended"
                  >
                    Cancel
                  </Fab>
                </div>
              </>
            )}

            {showPatient && (
              <>
                <PatientAgreement />
                <div className={classes.buttonWrap}>
                  <Fab
                    aria-label="agree"
                    className={classes.roundButton}
                    color="primary"
                    onClick={handleActivateAccount}
                    size="medium"
                    variant="extended"
                  >
                    {isLoading && (
                      <CircularProgress
                        size={20}
                        style={{ marginRight: 5 }}
                        color="inherit"
                      />
                    )}
                    Agree
                  </Fab>
                  <Fab
                    aria-label="cancel"
                    className={classes.roundButton}
                    color="default"
                    component={RouterLink}
                    size="medium"
                    to="/sign-up"
                    variant="extended"
                  >
                    Cancel
                  </Fab>
                </div>
              </>
            )}

            {showOwner && (
              <>
                <OwnerAgreement />
                <div className={classes.buttonWrap}>
                  <Fab
                    aria-label="agree"
                    className={classes.roundButton}
                    color="primary"
                    onClick={showSuccess}
                    size="medium"
                    variant="extended"
                  >
                    {isLoading && (
                      <CircularProgress
                        size={20}
                        style={{ marginRight: 5 }}
                        color="inherit"
                      />
                    )}
                    Agree
                  </Fab>
                  <Fab
                    aria-label="cancel"
                    className={classes.roundButton}
                    color="default"
                    component={RouterLink}
                    size="medium"
                    to="/sign-up"
                    variant="extended"
                  >
                    Cancel
                  </Fab>
                </div>
              </>
            )}

            {showterms.success && <Success values={values} />}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

Terms.propTypes = {
  history: PropTypes.object
};

const mapDispatchToProps = { activateAccount, getuserbytoken };
const mapStateToProps = state => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Terms))
);
